module.exports = __webpack_public_path__ + "static/media/ola_logo.739ea206.png";